import "./../../base";
import { handleFormSecurity } from "./../../security";
import documentReady from "./../../helpers/document-ready";
import formResponseHandler from "./../../helpers/form-response-handler";
import { pushToGa4 } from "../../helpers/pushToDataLayer";
import serialize from "form-serialize";

let csrfPopulated, action;

import("./../../validation").then(() => {
    documentReady(() => {
        handleFormSecurity().then(() => {
            csrfPopulated = true;
        });

        document.getElementsByClassName("c-small-form--email")[0].focus();

        const form = document.getElementsByClassName("c-small-form")[0];

        action = form.action;

        form.addEventListener("submit", ev => {
            ev.preventDefault();
            submitWhenReady(ev.target);
        });
    });
});

let submitTries = 0;
function submitWhenReady(form) {
    setSubmitButtonLoadingState(true);
    if (csrfPopulated) {
        return fetch(action, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: serialize(form),
            credentials: "include",
        })
            .then(result => {
                let action = 'small form';

                switch (form.id) {
                    case 'form-forgot-domain':
                        if (result.status === 200) {
                            pushToGa4(
                                "send_retrieve_forgotten_domain_success_f",
                                "advertiser authorization funnel",
                                "retrieve domain",
                                "undefined",
                            );
                        }
                        
                        action = 'retrieve forgotten domain';
                        break;
                    case 'form-resetting':
                        action = 'reset password';
                        break;
                }

                return result;
            })
            .then(formResponseHandler)
            .then(result => {
                if (result === false) {
                    handleFormSecurity().then(() => setSubmitButtonLoadingState(false));
                }
            });
    }

    setTimeout(() => {
        if (submitTries++ >= 100) {
            // @TODO: Show warning to user
            throw "Something went wrong";
        }

        submitWhenReady(form);
    }, 100);
}

function setSubmitButtonLoadingState(loading) {
    let button = document.getElementsByClassName("c-small-form__submit-button")[0];

    if (loading) {
        button.classList.add("c-button--loading");
        button.setAttribute("disabled", "");
    } else {
        button.classList.remove("c-button--loading");
        button.removeAttribute("disabled");
    }
}
